module.exports = __webpack_public_path__ + "static/covid-1-e0c69f65e2a719a8f2de630856a5d863.png";